import { render, staticRenderFns } from "./StockDetailEdit.vue?vue&type=template&id=e95157a4&scoped=true&"
import script from "./StockDetailEdit.vue?vue&type=script&lang=js&"
export * from "./StockDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockDetailEdit.vue?vue&type=style&index=0&id=e95157a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95157a4",
  null
  
)

export default component.exports